module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TO - Tonga.2d1b559b.svg";